module.exports = __webpack_public_path__ + "assets/img/btn-view-info-hover-79385af7.png";